const dayjs = require('dayjs')
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)
// use temporarily ranges from file until "handelsaktionen" is ready for development
const { offerRanges } = require('./offerRanges')

const allOffersQuery = today => ({
  bool: {
    must: [{ match: { global: true } }],
    filter: [
      {
        range: {
          validfrom: { lte: today }
        }
      },
      {
        range: {
          validto: { gte: today }
        }
      }
    ]
  }
})

const allOffersHighlightQuery = (today, isLoyaltyMarket) => {
  const query = {
    bool: {
      must: [{ match: { global: true } }],
      filter: [
        {
          range: {
            validfrom: { lte: today }
          }
        },
        {
          range: {
            validto: { gte: today }
          }
        },
        {
          bool: {
            should: [{ match: { marketHighlight: true } }]
          }
        }
      ]
    }
  }
  if (isLoyaltyMarket === false || isLoyaltyMarket === 'false') {
    query.bool.must_not = [{ term: { isAppExclusive: true } }]
  }
  return query
}

const allMarketOffersQuery = (today, marketId, isLoyaltyMarket) => {
  const query = {
    bool: {
      must: [],
      should: [
        { terms: { 'marketIdList.marketIds': [marketId] } },
        { match: { global: true } }
      ],
      minimum_should_match: 1,
      filter: [
        {
          range: {
            validfrom: { lte: today }
          }
        },
        {
          range: {
            validto: { gte: today }
          }
        }
      ]
    }
  }
  if (isLoyaltyMarket === false || isLoyaltyMarket === 'false') {
    query.bool.must_not = [{ term: { isAppExclusive: true } }]
  }
  return query
}

const allMarketOffersHighlightQuery = (today, marketId, isLoyaltyMarket) => {
  const query = {
    bool: {
      must: [{ match: { marketHighlight: true } }],
      should: [
        { terms: { 'marketIdList.marketIds': [marketId] } },
        { match: { global: true } }
      ],
      minimum_should_match: 1,
      filter: [
        {
          range: {
            validfrom: { lte: today }
          }
        },
        {
          range: {
            validto: { gte: today }
          }
        }
      ]
    }
  }
  if (isLoyaltyMarket === false || isLoyaltyMarket === 'false') {
    query.bool.must_not = [{ term: { isAppExclusive: true } }]
  }
  return query
}

const previewOffersQuery = (campaignStart, campaignEnd, today) => ({
  bool: {
    must: [{ match: { global: true } }],
    filter: [
      {
        range: { validfrom: { gte: campaignStart } } // campaignstart <= validfrom
      },
      {
        range: { validfrom: { gt: today } } // sonst beendet
      },
      {
        range: { validto: { lte: campaignEnd } } // campaignend >= validto
      }
    ]
  }
})

const previewMarketOffersQuery = (
  campaignStart,
  campaignEnd,
  today,
  marketId,
  isLoyaltyMarket
) => {
  const query = {
    bool: {
      must: [],
      should: [
        { term: { global: true } },
        { term: { 'marketIdList.marketIds': marketId } }
      ],
      minimum_should_match: 1,
      filter: [
        {
          range: { validfrom: { gte: campaignStart } } // campaignstart <= validfrom
        },
        {
          range: { validfrom: { gt: today } } // sonst beendet
        },
        {
          range: { validto: { lte: campaignEnd } } // campaignend >= validto
        }
      ]
    }
  }
  if (isLoyaltyMarket === false || isLoyaltyMarket === 'false') {
    query.bool.must_not = [{ term: { isAppExclusive: true } }]
  }
  return query
}

const getRangeDates = today => {
  // 2) anonymous function is passed to find
  return function (element) {
    return dayjs(today).isBetween(dayjs(element[0]), element[1], 'day', '[]')
  }
}
const findRangeForDate = today => {
  // 1) getRangesDates(xx) returns anonymous function
  return [...offerRanges].reverse().find(getRangeDates(today))
}

const offerQuery = (
  marketId,
  isOfferPreview,
  marketHighlights,
  isLoyaltyMarket
) => {
  const today = dayjs().format('YYYY-MM-DD')
  const startVisibileDateRange = findRangeForDate(today)
  const [campaignStart, campaignEnd] = startVisibileDateRange

  if (marketHighlights) return allOffersHighlightQuery(today, isLoyaltyMarket)

  if (marketId && marketHighlights)
    return allMarketOffersHighlightQuery(today, marketId, isLoyaltyMarket)

  if (marketId && isOfferPreview && today >= campaignStart)
    return previewMarketOffersQuery(campaignStart, campaignEnd, today, marketId)

  if (marketId) return allMarketOffersQuery(today, marketId, isLoyaltyMarket)

  if (isOfferPreview && today >= campaignStart)
    return previewOffersQuery(campaignStart, campaignEnd, today)

  return allOffersQuery(today)
}

module.exports = { offerQuery, findRangeForDate }
